import { getNftsRepository } from "../Infrastructure/Nfts.repository";

export async function getNftsLogic(params) {
  return getNftsRepository(params);
}